/**
 * The client picked in the client search (or the one already assigned to the appointment),
 * including the contact data the notification section displays.
 */
export interface AppointmentClientSelection {
  clientId: string;
  name: string;
  phone: string | null;
  email: string | null;
}

export interface AppointmentFormValues {
  isAllDay: boolean;
  startDate: Date;
  endDate: Date;
  purposeKey: string;
  location: string | null;
  details: string;
  /** Client picked via the search; null when none is picked or one is already assigned. */
  client: AppointmentClientSelection | null;
  notifyBySms: boolean;
  notifyByEmail: boolean;
  /** Edit only: the assigned client is struck through and removed on the next save. */
  clientMarkedForRemoval: boolean;
}

export const AppointmentMaxLength = {
  purposeKey: 255,
  location: 400,
  details: 250,
};
